import { render, staticRenderFns } from "./monitor.vue?vue&type=template&id=4951805a&"
import script from "./monitor.vue?vue&type=script&lang=js&"
export * from "./monitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4951805a')) {
      api.createRecord('4951805a', component.options)
    } else {
      api.reload('4951805a', component.options)
    }
    module.hot.accept("./monitor.vue?vue&type=template&id=4951805a&", function () {
      api.rerender('4951805a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/monitor.vue"
export default component.exports